import { getUserSession } from "../utils/auth";

const baseUrl = process.env.REACT_APP_BASE_URL;
const user_data = getUserSession();

console.log(user_data);
const AUTH_TOKEN = user_data?.token;
console.log(AUTH_TOKEN, '>>>>>>>>>>user_data');

const DEFAULT_BODY_PARAMS = {};

const serializeToQueryParams = (obj) => {
  const str = [];
  for (const p in obj) {
    if (obj.hasOwnProperty(p)) {
      let encodedValue = encodeURIComponent(obj[p]);
      // Replace any encoded "/" (%2F) with "/"
      encodedValue = encodedValue.replace(/%2F/g, "/");
      str.push(encodeURIComponent(p) + "=" + encodedValue);
    }
  }
  return str.join("&");
};

// Function to make API calls with fetch
export const makeApiCall = async (url, method, data = {}, options = {}) => {
  const { isPdfDownload = false } = options;
  
  const requestOptions = {
    method,
    headers: {
      // Default headers
      Authorization: `Bearer ${AUTH_TOKEN}`,
    },
  };

  // Set content type based on request type
  if (!isPdfDownload) {
    requestOptions.headers['Content-Type'] = 'application/json';
  } else {
    requestOptions.headers['Accept'] = 'application/pdf';
  }

  if (method === 'GET') {
    const queryParams = serializeToQueryParams({ ...DEFAULT_BODY_PARAMS, ...data });
    // Add query parameters based on whether it's a PDF download
    url += isPdfDownload ? `${queryParams}` : `?${queryParams}`;
  } else {
    // If method is POST or PUT, handle data as FormData
    if (method === 'POST' || method === 'PUT') {
      const formData = new FormData();
      // Append default body params first (if any)
      for (const [key, value] of Object.entries(DEFAULT_BODY_PARAMS)) {
        formData.append(key, value);
      }
      // Append provided data
      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }

      console.log("983ndms : ", formData.get('invoice_id'));
      
      for(let pair of formData.entries()) {
        console.log("hs8743 : ",pair[0]+',' + pair[1]);
      }

      requestOptions.body = formData;
      // Remove Content-Type header when using FormData
      delete requestOptions.headers['Content-Type'];

      console.log("2387hg : ", requestOptions);
    } else {
      // For other methods like DELETE, PATCH, etc., send JSON as the body
      requestOptions.body = JSON.stringify({ ...DEFAULT_BODY_PARAMS, ...data });
    }
  }

  try {
    const response = await fetch(`${url}`, requestOptions);
    
    // Return appropriate response based on request type
    if (isPdfDownload) {
      return await response;
    }
    return await response.json();
  } catch (error) {
    console.log(`API call failed for ${url}: ${error.message}`);
  }
};

// export const makeApiCall = async (url, method, data = {}, options = {}) => {
//   const { isPdfDownload = false } = options;
  
//   const requestOptions = {
//     method,
//     headers: {
//       Authorization: `Bearer ${AUTH_TOKEN}`,
//     },
//   };

//   // Set content type and accept headers based on request type
//   if (isPdfDownload) {
//     requestOptions.headers['Accept'] = 'application/pdf';
//     // For PDF downloads, don't set Content-Type to allow browser handling
//   } else {
//     requestOptions.headers['Content-Type'] = 'application/json';
//   }

//   if (method === 'GET') {
//     if (Object.keys(data).length > 0) {
//       const queryParams = serializeToQueryParams({ ...DEFAULT_BODY_PARAMS, ...data });
//       // Add query parameters based on whether it's a PDF download
//       url += isPdfDownload ? `${queryParams}` : `?${queryParams}`;
//     }
//   } else {
//     if (method === 'POST' || method === 'PUT') {
//       if (data instanceof FormData) {
//         requestOptions.body = data;
//         delete requestOptions.headers['Content-Type'];
//       } else {
//         const formData = new FormData();
//         for (const [key, value] of Object.entries({ ...DEFAULT_BODY_PARAMS, ...data })) {
//           formData.append(key, value);
//         }
//         requestOptions.body = formData;
//         delete requestOptions.headers['Content-Type'];
//       }
//     } else {
//       requestOptions.body = JSON.stringify({ ...DEFAULT_BODY_PARAMS, ...data });
//     }
//   }

//   try {
//     const response = await fetch(url, requestOptions);
    
//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }
    
//     // Handle different response types
//     if (isPdfDownload) {
//       return response.blob();
//     }
    
//     // Try to parse as JSON, fallback to text if not possible
//     try {
//       return await response.json();
//     } catch (e) {
//       return await response.text();
//     }
//   } catch (error) {
//     console.error(`API call failed for ${url}: ${error.message}`);
//     throw error;
//   }
// };